@if (showHeader) {
  <div class="np-head">
    <span class="np-title">{{ headerLabel }}</span>
    <span class="np-count">{{ filteredNetworks.length }}</span>
  </div>
}

<div class="np-search">
  <svg class="np-search__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
  <input
    #netSearch
    type="text"
    [(ngModel)]="netFilter"
    (ngModelChange)="activeIndex = 0; filterChange.emit($event)"
    (keydown)="onSearchKeydown($event)"
    [placeholder]="placeholder"
    [attr.aria-label]="'Filter ' + itemNoun"
  />
</div>

<div class="np-list" #pickerList role="listbox">
  @if (showClear) {
    <button
      type="button"
      role="option"
      class="np-item np-item--clear"
      [class.is-current]="clearIsCurrent"
      [attr.aria-selected]="clearIsCurrent"
      (click)="selectClear()"
    >
      <svg class="np-clearicon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="m5.6 5.6 12.8 12.8" />
      </svg>
      <span class="np-name">{{ clearLabel }}</span>
      @if (clearIsCurrent) {
        <svg class="np-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M20 6 9 17l-5-5" />
        </svg>
      }
    </button>
  }

  @for (net of filteredNetworks; track net.id; let i = $index) {
    <button
      type="button"
      role="option"
      class="np-item"
      [class.is-current]="net.id === currentNetworkId"
      [class.is-active]="i === activeIndex"
      [attr.aria-selected]="net.id === currentNetworkId"
      (mouseenter)="activeIndex = i"
      (click)="selectNetwork(net)"
    >
      <span class="np-dot" [ngClass]="'is-' + statusDotClass(net)" aria-hidden="true"></span>
      <span class="np-name" [title]="net.name">{{ net.name }}</span>
      @if (net.haEnabled) {
        <span class="np-tag np-tag--ha">HA</span>
      }
      @if (net.fipsEnabled) {
        <span class="np-tag np-tag--fips">FIPS</span>
      }
      @if (statusWord(net); as word) {
        <span class="np-status" [ngClass]="'is-' + statusDotClass(net)">{{ word }}</span>
      }
      @if (net.id === currentNetworkId) {
        <svg class="np-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M20 6 9 17l-5-5" />
        </svg>
      }
    </button>
  } @empty {
    <div class="np-empty">No {{ itemNoun }} match &ldquo;{{ netFilter }}&rdquo;</div>
  }
</div>

@if (showFooter) {
  <div class="np-foot">
    <a class="np-manage" [routerLink]="manageLink" (click)="onManage()">{{ manageLabel }}</a>
    <span class="np-hint" aria-hidden="true">&uarr;&darr; &middot; &crarr; &middot; esc</span>
  </div>
}
